// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/login/background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/login/check.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signUpPage{
    position: relative;
    /*padding: 15px 36px;*/
    width: 100%;
    height: 100vh;
}

.signUpPage_background{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    max-height: 300px;
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
}
         
.signUpPage_wrapper{
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fffb;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding: 0px 12px;
}

.signUpPage_header{
    padding: 46px 77px;
    padding-bottom: 0px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.signUpPage_logo{
    font-weight: 800;
    font-size: 19px;
    line-height: 33px;
    text-align: center;
    color: #212121;
    text-transform: uppercase;
}

.signUpPage_signUp{
    border: 1.20833px solid #000000;
    border-radius: 24px;

    font-weight: 800;
    font-size: 10px;
    line-height: 18px;
    color: #212121;
    padding: 10px 28px;
    text-transform: uppercase;
}
                
.signUpPage_main{
    display: flex;
    justify-content: center;
    align-items: center;
}

.signUpPopup{
    background: #FFFFFF;
    border: 0.805556px solid #E0E0E0;
    box-shadow: 0px 66.0556px 32.2222px -11.2778px rgba(100, 100, 100, 0.0784314);
    border-radius: 24px;
    padding: 46px 77px;
    max-width: 465px;
    width: 100%;
}

.signUpPopup_title{
    font-weight: 700;
    font-size: 25px;
    line-height: 30px;
    text-align: center;
    color: #000000;

    margin-bottom: 15px;
}                      
                        
.signUpPopup_form{
    margin-bottom: 26px;
}

.signUpPopup_input{
    margin-bottom: 7px;
}

.signUpPopup_input_label{
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;

    color: #3B4256;
    margin-bottom: 5px;
}                              
                                
.signUpPopup_input_field{
    border: none;
    width: 100%;
    height: 39px;
    background: #F3F6FF;
    border-radius: 30px;

    font-weight: 400;
    font-size: 10px;
    line-height: 150%;
    color: #B8BCCA;
    padding: 0px 20px;
}                                                                                   
                            
.signUpPopup_remember{
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding-top: 12px;
    padding-bottom: 14px;
}

.signUpPopup_check{
    display: flex;
    gap: 7px;
}

.signUpPopup_check_box{
    width: 17px;
    height: 17px;
    border: 1px solid #212121;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 12px;
}
                                                             
.signUpPopup_check_label{
    font-weight: 400;
    font-size: 9px;
    line-height: 18px;
    text-decoration-line: underline;

    color: #616161;
}
                             
.signUpPopup_forgotPassword{
    font-weight: 400;
    font-size: 9px;
    line-height: 18px;
    text-decoration-line: underline;
    
    color: #616161;    
}
                          
.signUpPopup_submit{
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FFA825;
    border-radius: 24px;
    height: 51px;

    font-weight: 500;
    font-size: 13px;
    line-height: 23px;
    text-align: center;
    text-transform: uppercase;
    color: #FFFFFF;
}
                   
.signUpPopup_otherAuth{
    display: flex;
    align-items: center;
    flex-direction: column;
}

.signUpPopup_otherAuth_or{
    margin-bottom: 18px;
}

.signUpPopup_otherAuth_google{
    display: flex;
    justify-content: center;
    padding: 12px;
    border: 1px solid #999;
    border-radius: 30px;
}

.signUpPopup_otherAuth_google_ico{

}
                        
.signUpPopup_otherAuth_google_text{

}

.signUpPage_footer{
    padding: 46px 77px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.signUpPage_footer_text{
    font-weight: 400;
    font-size: 8px;
    line-height: 11px;
    text-align: right;
    letter-spacing: 0.563889px;

    color: #616161;
}
                
                `, "",{"version":3,"sources":["webpack://./src/pages/signUpPage/SignUpPage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAA0D;IAC1D,iBAAiB;IACjB,sBAAsB;IACtB,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;;IAEnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,6EAA6E;IAC7E,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;;IAEd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;;IAEnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yDAAqD;IACrD,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,+BAA+B;;IAE/B,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,+BAA+B;;IAE/B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;;IAEZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;;IAE1B,cAAc;AAClB","sourcesContent":[".signUpPage{\n    position: relative;\n    /*padding: 15px 36px;*/\n    width: 100%;\n    height: 100vh;\n}\n\n.signUpPage_background{\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url('../../assets/login/background.png');\n    max-height: 300px;\n    background-size: cover;\n    background-position: top center;\n    background-repeat: no-repeat;\n}\n         \n.signUpPage_wrapper{\n    position: relative;\n    width: 100%;\n    height: 100%;\n    background-color: #fffb;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    padding: 0px 12px;\n}\n\n.signUpPage_header{\n    padding: 46px 77px;\n    padding-bottom: 0px;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.signUpPage_logo{\n    font-weight: 800;\n    font-size: 19px;\n    line-height: 33px;\n    text-align: center;\n    color: #212121;\n    text-transform: uppercase;\n}\n\n.signUpPage_signUp{\n    border: 1.20833px solid #000000;\n    border-radius: 24px;\n\n    font-weight: 800;\n    font-size: 10px;\n    line-height: 18px;\n    color: #212121;\n    padding: 10px 28px;\n    text-transform: uppercase;\n}\n                \n.signUpPage_main{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.signUpPopup{\n    background: #FFFFFF;\n    border: 0.805556px solid #E0E0E0;\n    box-shadow: 0px 66.0556px 32.2222px -11.2778px rgba(100, 100, 100, 0.0784314);\n    border-radius: 24px;\n    padding: 46px 77px;\n    max-width: 465px;\n    width: 100%;\n}\n\n.signUpPopup_title{\n    font-weight: 700;\n    font-size: 25px;\n    line-height: 30px;\n    text-align: center;\n    color: #000000;\n\n    margin-bottom: 15px;\n}                      \n                        \n.signUpPopup_form{\n    margin-bottom: 26px;\n}\n\n.signUpPopup_input{\n    margin-bottom: 7px;\n}\n\n.signUpPopup_input_label{\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 150%;\n\n    color: #3B4256;\n    margin-bottom: 5px;\n}                              \n                                \n.signUpPopup_input_field{\n    border: none;\n    width: 100%;\n    height: 39px;\n    background: #F3F6FF;\n    border-radius: 30px;\n\n    font-weight: 400;\n    font-size: 10px;\n    line-height: 150%;\n    color: #B8BCCA;\n    padding: 0px 20px;\n}                                                                                   \n                            \n.signUpPopup_remember{\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    padding-top: 12px;\n    padding-bottom: 14px;\n}\n\n.signUpPopup_check{\n    display: flex;\n    gap: 7px;\n}\n\n.signUpPopup_check_box{\n    width: 17px;\n    height: 17px;\n    border: 1px solid #212121;\n    background-image: url(\"../../assets/login/check.svg\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 12px;\n}\n                                                             \n.signUpPopup_check_label{\n    font-weight: 400;\n    font-size: 9px;\n    line-height: 18px;\n    text-decoration-line: underline;\n\n    color: #616161;\n}\n                             \n.signUpPopup_forgotPassword{\n    font-weight: 400;\n    font-size: 9px;\n    line-height: 18px;\n    text-decoration-line: underline;\n    \n    color: #616161;    \n}\n                          \n.signUpPopup_submit{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #FFA825;\n    border-radius: 24px;\n    height: 51px;\n\n    font-weight: 500;\n    font-size: 13px;\n    line-height: 23px;\n    text-align: center;\n    text-transform: uppercase;\n    color: #FFFFFF;\n}\n                   \n.signUpPopup_otherAuth{\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n}\n\n.signUpPopup_otherAuth_or{\n    margin-bottom: 18px;\n}\n\n.signUpPopup_otherAuth_google{\n    display: flex;\n    justify-content: center;\n    padding: 12px;\n    border: 1px solid #999;\n    border-radius: 30px;\n}\n\n.signUpPopup_otherAuth_google_ico{\n\n}\n                        \n.signUpPopup_otherAuth_google_text{\n\n}\n\n.signUpPage_footer{\n    padding: 46px 77px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.signUpPage_footer_text{\n    font-weight: 400;\n    font-size: 8px;\n    line-height: 11px;\n    text-align: right;\n    letter-spacing: 0.563889px;\n\n    color: #616161;\n}\n                \n                "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
